import AddAccount from '../../components/AddAccount';
import MailinatorCleanup, {DeleteAccountButton} from "../../components/MailinatorCleanup";
import {serviceNames} from './profile';
import ArchivedAccountDetails from "../../components/ArchivedAccountDetails";
import React, { useState } from "react";
import {
  Box,
  Button,
  Flex,
  Input,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Spinner,
} from "@chakra-ui/react";
import { FaSearch } from "react-icons/fa";
import { InputGroup, InputLeftElement } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import useAccountDirectory from "../../utils/useAccountDirectory";
import UserExport from "../../components/UserExport";
import DirectoryCount from '../../components/DirectoryCount';
import AccountDirectoryFilters, {directoryDateError, directoryFilterParams, emptyDirectoryFilters} from '../../components/AccountDirectoryFilters';

const Provider1 = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchName, setSearchName] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [searchBusiness, setSearchBusiness] = useState("");
  const [searchPhone, setSearchPhone] = useState("");
  const navigate = useNavigate();
  const [showDeleted, setShowDeleted] = useState(false);
  const [archivedRecord, setArchivedRecord] = useState<any>(null);

  const itemsPerPage = 25;
  const [filters,setFilters] = useState(emptyDirectoryFilters);
  const dateError = directoryDateError(filters);
  const searchFilters = Object.fromEntries(Object.entries({firstName:searchName, email:searchEmail, phoneNumber:searchPhone, name:searchBusiness}).filter(([,v])=>v.trim()).map(([key,v])=>[key,v.trim()]));
  const requestFilters = {...searchFilters, ...directoryFilterParams(filters)};

  const {records: providers, loading, totalRecords, error, refresh} = useAccountDirectory('providers', currentPage, showDeleted, requestFilters, !dateError);
  const changeSearch = (setter: React.Dispatch<React.SetStateAction<string>>) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setter(e.target.value);
    setCurrentPage(1);
  };
  const handlePageChange = (page: number) => setCurrentPage(page);

  const handleCustomerClick = (provider: any) => {
    if (provider.deleted) { setArchivedRecord(provider); return; }
    navigate(`/provider/${provider._id}`);
  };

  return (
    <Box p={{base: 3, md: 5}} minW={0}>
      <Flex gap={3} justify="space-between" align="start" wrap="wrap"><MailinatorCleanup onRemoved={refresh} /><DirectoryCount total={totalRecords} loading={loading} unavailable={error||!!dateError}/></Flex>
      <Flex justify="flex-end" my={4}><AddAccount role="provider" onCreated={()=>{setCurrentPage(1);setShowDeleted(false);setSearchName('');setSearchEmail('');setSearchPhone('');setFilters(emptyDirectoryFilters());refresh();setSearchBusiness('');}} onView={id=>navigate(`/provider/${id}`)}/></Flex>
      <ArchivedAccountDetails record={archivedRecord} onClose={() => setArchivedRecord(null)} />
      <label style={{display: "block", marginBottom: 16}}><input type="checkbox" checked={showDeleted} onChange={e => {setShowDeleted(e.target.checked); setCurrentPage(1);}} /> Show deleted accounts</label>
      <Flex justifyContent="space-between" mb={4} wrap="wrap">
        <Flex wrap="wrap" gap={2}>
          <InputGroup width={{base: "100%", sm: "250px"}} marginRight={{base: 0, sm: 4}}>
            <InputLeftElement pointerEvents="none" children={<FaSearch color="var(--admin-muted)" />} />
            <Input
              placeholder="Search by Name"
              value={searchName}
              onChange={changeSearch(setSearchName)}
            />
          </InputGroup>
          <InputGroup width={{base: "100%", sm: "250px"}} marginRight={{base: 0, sm: 4}}>
            <InputLeftElement pointerEvents="none" children={<FaSearch color="var(--admin-muted)" />} />
            <Input
              placeholder="Search by Email"
              value={searchEmail}
              onChange={changeSearch(setSearchEmail)}
            />
          </InputGroup>
          <InputGroup width={{base: "100%", sm: "250px"}} marginRight={{base: 0, sm: 4}}>
            <InputLeftElement pointerEvents="none" children={<FaSearch color="var(--admin-muted)" />} />
            <Input
              placeholder="Search by Business Name"
              value={searchBusiness}
              onChange={changeSearch(setSearchBusiness)}
            />
          </InputGroup>

          <InputGroup width={{base: "100%", sm: "250px"}} marginRight={{base: 0, sm: 4}}>
            <InputLeftElement pointerEvents="none" children={<FaSearch color="var(--admin-muted)" />} />
            <Input
              type="tel"
              aria-label="Search by Phone Number"
              placeholder="Search by Phone Number"
              value={searchPhone}
              onChange={changeSearch(setSearchPhone)}
            />
          </InputGroup>
        </Flex>
      </Flex>

      <AccountDirectoryFilters role="providers" deleted={showDeleted} value={filters} onChange={value=>{setFilters(value);setCurrentPage(1);}} onClear={()=>{setFilters(emptyDirectoryFilters());setSearchName('');setSearchEmail('');setSearchPhone('');setSearchBusiness('');setCurrentPage(1);}} />
      <UserExport role="providers" filters={requestFilters} disabled={loading||error||!!dateError} deleted={showDeleted} />

      {dateError ? null : loading ? (
        <Spinner size="xl" />
      ) : (
        <Box>
          <Box overflowX="auto" maxW="100%" tabIndex={0} role="region" aria-label="Service providers table">
          <Table variant="striped" >
            <Thead backgroundColor="#88077b">
              <Tr>
                <Th color="white">Name</Th>
                <Th color="white">Services</Th>
                <Th color="white">Phone Number</Th>
                <Th color="white">Email</Th>
                <Th color="white">Date of Birth</Th>
                <Th color="white">State</Th>
                <Th color="white">Address</Th>
                <Th color="white">Registered (Lagos)</Th>
                <Th color="white">Account Type</Th>
                <Th color="white" position="sticky" right={0} bg="#88077b" zIndex={1}>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {providers.map((customer, index) => (
                <Tr
                  key={customer._id || customer.id}
                  onClick={() => handleCustomerClick(customer)}
                  _hover={{ cursor: "pointer", backgroundColor: "admin.subtle" }}
                  backgroundColor={index % 2 === 0 ? "admin.surface" : "admin.selected"}
                >
                  <Td><Button variant="link" color="admin.text" whiteSpace="normal" textAlign="left" onClick={event => {event.stopPropagation(); handleCustomerClick(customer);}}>{customer?.businessName || `${customer.firstName} ${customer.lastName}`}</Button></Td>
                  <Td minW="200px" maxW="320px">
                    <Flex direction="column" align="start" gap={2}>
                      {serviceNames(customer.services).map(name => <Button key={name} variant="link" colorScheme="purple" whiteSpace="normal" textAlign="left"
                        onClick={event => {event.stopPropagation(); handleCustomerClick(customer);}}>{name}</Button>)}
                      {!serviceNames(customer.services).length && <Text color="admin.muted" fontSize="sm">{customer.services?.length ? 'Service details unavailable' : 'No services added'}</Text>}
                    </Flex>
                  </Td>
                  <Td>{customer.phoneNumber}</Td>
                  <Td>{customer.email}</Td>
                  <Td>{new Date(customer.dob).toLocaleDateString()}</Td>
                  <Td>{customer.state}</Td>
                  <Td>{customer.address}</Td>
                  <Td whiteSpace="nowrap">{customer.createdAt && Number.isFinite(Date.parse(customer.createdAt)) ? new Date(customer.createdAt).toLocaleDateString('en-GB',{timeZone:'Africa/Lagos',day:'numeric',month:'short',year:'numeric'}) : 'Not available'}</Td>
                  <Td>{customer.accountType}</Td>

                  <Td position="sticky" right={0} bg={index % 2 === 0 ? 'admin.surface' : 'admin.selected'} zIndex={1}>
                    <DeleteAccountButton account={customer} onRemoved={refresh} />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
          </Box>

          <Flex justifyContent="flex-end" mt={4} backgroundColor="#88077b" p={3}>
            <Button
              ml={4}
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              backgroundColor="#88077b"
              color="white"
              _hover={{ backgroundColor: "#660563" }}
            >
              Previous
            </Button>
            <Text color="white" mt={2}>
              {`${totalRecords ? (currentPage - 1) * itemsPerPage + 1 : 0} - ${Math.min(currentPage * itemsPerPage, totalRecords)} of ${totalRecords}`}
            </Text>
            <Button
              ml={4}
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage * itemsPerPage >= totalRecords}
              backgroundColor="#88077b"
              color="white"
              _hover={{ backgroundColor: "#660563" }}
            >
              Next
            </Button>
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default Provider1;
